<div [ngClass]="sidebarService.sidebarCssClass || ''">
  <div class="sidebar-toggle-button" (click)="toggleSidebar()">
    <i class="material-icons">{{
      sidebarService.isMinimized ? 'chevron_left' : 'chevron_right'
    }}</i>
  </div>

  @if (sidebarService.template) {
  <ng-container *ngTemplateOutlet="sidebarService.template"></ng-container>
  } @if (!sidebarService.template) { @if (sidebarService.actionTabs?.length > 0) {
  <div class="sidebar-content">
    <div class="cm-title sidebar-head">{{ sidebarService.sidebarTitle || 'Contents' }}</div>
    <cm-action-tabs-panel [actionTabs]="sidebarService.actionTabs"></cm-action-tabs-panel>
  </div>
  } @if (sidebarService.filterFormControls && sidebarService.sidebarFilters.length > 0) {
  <div class="sidebar-content filters">
    <div class="cm-title sidebar-head">
      <span>{{
        sidebarService?.sidebarFilterTitle ||
          sidebarService?.sidebarTitle ||
          (sidebarService.sidebarButton ? 'Report' : 'Filters')
      }}</span>
    </div>
    <cm-filter-panel [filters]="sidebarService.sidebarFilters"></cm-filter-panel>
    @if (!sidebarService.sidebarButton) {
    <div class="sidebar-footer-actions">
      @if (isFiltersDirty()) {
      <span class="reset-action" (click)="sidebarService.resetFiltersForm()">Reset</span>
      }
    </div>
    } @if (sidebarService.sidebarButton) {
    <div style="display: flex; justify-content: space-between; align-items: center">
      <lib-utmc-button
        (onClick)="sidebarService.sidebarButton.onClick()"
        [color]="sidebarService.sidebarButton.color"
        [disabled]="
          sidebarService.sidebarButton.disabled ? sidebarService.sidebarButton.disabled() : false
        "
        [isNoTracking]="
          sidebarService.sidebarButton.isNoTracking
            ? sidebarService.sidebarButton.isNoTracking()
            : false
        "
        matomoTrigger
        [triggerId]="sidebarService.sidebarButton.id"
        style="margin-left: 3px"
      >
        @if (sidebarService.sidebarButton.icon) {
        <i class="material-icons">{{ sidebarService.sidebarButton.icon }}</i>
        }
        {{ sidebarService.sidebarButton.title }}
      </lib-utmc-button>
      @if (sidebarService?.resetButton && sidebarService?.resetButton.visible()) {
      <div class="sidebar-footer-actions">
        <span class="reset-action" (click)="sidebarService?.resetButton.onClick()">Reset</span>
      </div>
      }
    </div>
    }
  </div>
  } @if (sidebarService?.rowsInformation && sidebarService?.rowsInformation?.length) {
  <div class="sidebar-content">
    <div class="cm-title sidebar-head">{{ sidebarService.sidebarTitle || 'Contents' }}</div>
    <cm-raws-info-panel [rawsInfo]="sidebarService.rowsInformation"></cm-raws-info-panel>
  </div>
  } }
</div>
<!--<sidebar-content></sidebar-content>-->
